export default "__VITE_ASSET__DbWNdKqZ__"